import { api } from '@/lib/api';

export interface Notification {
  id: string;
  titulo: string;
  descricao: string;
  dataLembrete: string;
  executado: boolean;
  tituloId: string;
  userId: string;
  createdAt: string;
  tituloRef?: {
    id: string;
    numero: string;
    company: {
      id: string;
      name: string;
    };
  };
}

export interface CreateLembreteRequest {
  tituloId: string;
  titulo: string;
  descricao: string;
  dataLembrete: string;
  userId?: string;
}

export class NotificationService {
  static async getNotifications() {
    const response = await api.get('/titulos/lembretes');
    return response.data.data;
  }

  static async markAsRead(notificationId: string) {
    const response = await api.put(`/titulos/lembretes/${notificationId}/read`);
    return response.data;
  }

  static async markAllAsRead() {
    const response = await api.put('/titulos/lembretes/read-all');
    return response.data;
  }

  static async createLembrete(data: CreateLembreteRequest) {
    const response = await api.post('/titulos/lembrete', data);
    return response.data;
  }

  static async getUnreadCount() {
    const response = await api.get('/titulos/lembretes');
    const lembretes = response.data.data.lembretes || [];
    return lembretes.filter((n: Notification) => !n.executado).length;
  }
}
